import React from "react";
import styled from "styled-components";
import { Container } from "react-bootstrap";
import { trackEvent } from "../../lib/openings";

const Section = styled.section`
  padding: 16px 0 48px;
  background: var(--nd-black);
`;

const Inner = styled.div`
  background: var(--nd-surface-raised);
  border: 1px solid var(--nd-border-visible);
  border-radius: 12px;
  padding: 24px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Kicker = styled.span`
  font-family: 'Space Mono', monospace;
  font-size: 10px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--nd-text-disabled);
`;

const Headline = styled.span`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 16px;
  color: var(--nd-text-display);
`;

const Button = styled.a`
  font-family: 'Space Mono', monospace;
  font-size: 13px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  background: var(--nd-text-display);
  color: var(--nd-black) !important;
  border: none;
  border-radius: 999px;
  padding: 14px 28px;
  min-height: 44px;
  cursor: pointer;
  text-decoration: none !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: opacity 200ms ease;
  &:hover { opacity: 0.85; color: var(--nd-black) !important; }
`;

const isPlaceholder = (url) =>
  !url || url.includes("PLACEHOLDER") || url.trim() === "";

const LinkedInCta = ({ opening }) => {
  const url = opening.linkedinJobUrl;
  if (isPlaceholder(url)) return null;
  const onClick = () => {
    trackEvent("linkedin_click", { opening_id: opening.id, opening_slug: opening.slug });
  };
  return (
    <Section>
      <Container>
        <Inner>
          <Text>
            <Kicker>PREFER LINKEDIN?</Kicker>
            <Headline>Apply through the LinkedIn job post.</Headline>
          </Text>
          <Button
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClick}
            aria-label={`Apply on LinkedIn for ${opening.title}`}
          >
            Apply on LinkedIn ↗
          </Button>
        </Inner>
      </Container>
    </Section>
  );
};

export default LinkedInCta;
